module.exports = __webpack_public_path__ + "img/light_pairing_mode.5b7b9673.png";